import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Redirect } from "react-router-dom";

import {
  Button,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  Radio,
  RadioGroup,
} from "@material-ui/core";

import { startAlerta } from "../../../actions/ui/alertas";

import { STEPPER_RECETAS, TIPOS_RECETAS } from "../../../utils/constants";

import { RecetasDigitalesCard } from "../UI/RecetasDigitalesCard";
import { confirmarReceta, setActiveStep } from "../../../actions/recetasDigitales/RecetasDigitales";

export const RecetasDigitalesConfirmacion = () => {
  const dispatch = useDispatch();

  const { recetaSeleccionada = {} } = useSelector((state) => state.recetasDigitales);
  const { hceSeleccionada = null } = useSelector((state) => state.hce);

  let idRecetaDigital = 0;

  if (!!recetaSeleccionada) {
    idRecetaDigital = recetaSeleccionada?.idRecetaDigital;
  }

  const [imprimirPDF, setImprimirPDF] = useState("imprimirPDF");
  const [redirect, setRedirect] = useState(false);

  const onClickConfirmarHandler = () => {
    const imprimir = imprimirPDF === "imprimirPDF" ? true : false;
    if (imprimir === null) {
      dispatch(startAlerta(`Seleccione que desea hacer con la Receta.`, "error"));
    } else {
      if (idRecetaDigital !== 0) {
        dispatch(confirmarReceta(idRecetaDigital, imprimir, setRedirect));
      } else {
        dispatch(startAlerta(`No se encontro la receta.`, "error"));
      }
    }
  };

  return (
    <RecetasDigitalesCard width={"55%"}>
      <Grid container>
        <Grid
          item
          xs={12}
          style={{
            display: "flex",
            justifyContent: "center",
            marginTop: "1.5rem",
          }}
        >
          <FormControl>
            <FormLabel style={{ fontSize: "1.2rem" }}>{/*Urgente:*/}</FormLabel>
            <RadioGroup
              value={imprimirPDF}
              onChange={(e) => setImprimirPDF(e.target.value)}
            >
              <FormControlLabel
                value={"enviarMail"}
                control={<Radio />}
                label="Enviar por email"
              />
              <FormControlLabel
                value={"imprimirPDF"}
                control={<Radio />}
                label="Imprimir PDF"
              />
            </RadioGroup>
          </FormControl>
        </Grid>
      </Grid>
      <div
        style={{ display: "flex", justifyContent: "center", margin: "2rem" }}
      >
        <Button
          variant="contained"
          color="secondary"
          style={{ marginRight: "3rem" }}
          onClick={() => {
            if (recetaSeleccionada.idTipoReceta === TIPOS_RECETAS.PRESCRIPCION) {
              dispatch(setActiveStep(STEPPER_RECETAS.DETALLE_RECETA));
            } else {
              dispatch(setActiveStep(STEPPER_RECETAS.MEDICAMENTOS));
            }
          }}
        >
          Anterior
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={onClickConfirmarHandler}
        >
          Confirmar
        </Button>
      </div>
      {redirect && !hceSeleccionada?.idAfiliado && !hceSeleccionada?.idAfiliadoExterno && (
        <Redirect
          to={{
            pathname: "/recetasDigitales",
          }}
        />
      )}
    </RecetasDigitalesCard>
  );
};
